import * as React from "react";
import ReadMoreReact from 'read-more-react';
import {IReadPostResponse} from "../../core/api/post/response/ReadPostResponse";

interface IProps {
    data: IReadPostResponse | null;
}

interface IState {
    item: {}
}

export class HomeHistory extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            item: {}
        }
    }

    public render() {
        return (
            <section id="about" className="page-section">
                <div className="container relative">
                    <h2 className="section-title font-alt align-left mb-70 mb-sm-40">
                        Sejarah Desa
                    </h2>
                    <div className="section-text">
                        <div className="row">
                            <div className="col-md-4 mb-sm-50 mb-xs-30">
                                <img src="http://static.asiawebdirect.com/m/bangkok/portals/bali-indonesia-com/homepage/sanur/attractions/pagePropertiesImage/sanur-attractions.jpg.jpg" alt="image" />
                            </div>
                            <div className="col-md-8 mb-sm-50 mb-xs-30">
                                {this.props.data === null || this.props.data === undefined ? <div>Data tidak ditemukan</div> : (
                                    <ReadMoreReact text={this.props.data.description}
                                                   min={500}
                                                   ideal={500}
                                                   max={600}
                                                   readMoreText="baca lebih lanjut" />
                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}


// WEBPACK FOOTER //
// ./src/component/home/HomeHistory.tsx